import type { StateCreator } from 'zustand';
import type { AppStore, AuthSlice, User } from '../types';

const initialAuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

export const createAuthSlice: StateCreator<AppStore, [], [], AuthSlice> = (set) => ({
  ...initialAuthState,

  setUser: (user: User | null) =>
    set({ user, isAuthenticated: user !== null }),

  setLoading: (isLoading: boolean) =>
    set({ isLoading }),

  setError: (error: string | null) =>
    set({ error }),

  login: (user: User) =>
    set({
      user,
      isAuthenticated: true,
      isLoading: false,
      error: null,
    }),

  logout: () =>
    set({
      user: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,
    }),
});
